module.exports = __webpack_public_path__ + "public/images/expert_img.830d853e87d5ec90327cc73e4d28440f.jpg";